import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import IncentiveOfferOperationPurchaseContractPreview from 'modules/incentivesMarket/components/IncentiveOfferOperationPurchaseContractPreview';

import { useGenerateIncentiveOfferPurchaseContractModal } from '../context/GenerateIncentiveOfferPurchaseContractModalContext';

const GenerateIncentiveOfferPurchaseContractModalBody: FC = () => {
  const { t, i18n } = useTranslate();
  const { data } = useGenerateIncentiveOfferPurchaseContractModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <p className="text-soft mb-3">
          {t('IncentivesMarketPurchaseContractPreviewTitle')}
        </p>

        {data.templateId ? (
          <IncentiveOfferOperationPurchaseContractPreview
            templateId={data.templateId}
            societyId={data.societyId}
            operationId={data.operationId}
            language={i18n.language}
          />
        ) : (
          <p className="text-soft mb-0 px-3 py-2">
            {t('ErrorNoIncentivesMarketTemplate')}
          </p>
        )}
      </div>
    </Modal.Body>
  );
};

export default GenerateIncentiveOfferPurchaseContractModalBody;
